import axios from "axios";
import { APIClient } from "../../../helpers/api_helper";
import * as url from "../../../helpers/url_helper";

const api = new APIClient();

  export const createInstruction = async (data) => {
      try {
        const response = await api.create('/instructions/', data);
        return response;
      } catch (error) {
        throw error;
      }
  };

  export const getInstruction = async () => {
      try {                                                                            
        const response = await api.get(url.GET_INSTRUCTIONS);
        return response;
      } catch (error) {
        throw error;
      }
  };
  

  export const updateInstruction = async ( id, data) => {
      try {
        const response = await axios.patch(url.UPDATE_INSTRUCTIONS +'/'+id, data);
        return response;
      } catch (error) {
        throw error;
      }
  };

  export const deleteInstruction = async (id) => {
    try {
        const response = await api.delete(url.DELETE_INSTRUCTIONS +'/'+id);
        return response;
    } catch (error) {
        throw error;
    }
  };
